import { render, staticRenderFns } from "./SearchNotification.vue?vue&type=template&id=0d9b1a92&scoped=true&lang=pug"
import script from "./SearchNotification.vue?vue&type=script&lang=ts"
export * from "./SearchNotification.vue?vue&type=script&lang=ts"
import style0 from "./SearchNotification.vue?vue&type=style&index=0&id=0d9b1a92&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9b1a92",
  null
  
)

export default component.exports